// extracted by mini-css-extract-plugin
export default {"content":"PropertyMappingDialog_content__hUTJD","hint":"PropertyMappingDialog_hint__cacFe"};